export function isJsonString(json: string) {
    try {
        JSON.parse(json);
    } catch (error) {
        return false;
    }
    return true;
}